/* eslint-disable no-undef */

import thunkMiddleware from 'redux-thunk';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import paymentDetailsReducer from './payment-details-reducer.js';

const reducers = combineReducers({
	paymentDetails: paymentDetailsReducer,
});

window.store = createStore(reducers, applyMiddleware(thunkMiddleware));

const reduxStore = window.store;
export default reduxStore;
